import { render, staticRenderFns } from "./SubjectReportListByStudentAndAchievement.vue?vue&type=template&id=6442de82"
import script from "./SubjectReportListByStudentAndAchievement.vue?vue&type=script&lang=js"
export * from "./SubjectReportListByStudentAndAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6442de82')) {
      api.createRecord('6442de82', component.options)
    } else {
      api.reload('6442de82', component.options)
    }
    module.hot.accept("./SubjectReportListByStudentAndAchievement.vue?vue&type=template&id=6442de82", function () {
      api.rerender('6442de82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/SubjectReportListByStudentAndAchievement.vue"
export default component.exports